import { OrthographicCamera,Vector3 } from 'three'

export const CRATER_GROUND_SIZE=12000

// Orthographic zoom changes framing, not camera distance. At a tall aspect
// ratio, the foreground ground can therefore lie behind the near clipping
// plane. Move back along the same view direction without changing its scale.
export function frameCraterTerrain(camera:OrthographicCamera,target:Vector3){
  const direction=camera.position.clone().sub(target).normalize()
  const halfHeight=(camera.top-camera.bottom)/(2*camera.zoom)
  const groundDepth=halfHeight*Math.hypot(direction.x,direction.z)/Math.max(.1,direction.y)
  const distance=groundDepth+Math.abs(target.y)+300
  camera.position.copy(target).addScaledVector(direction,distance)
  camera.far=distance+groundDepth+1600
  camera.updateProjectionMatrix();camera.updateMatrixWorld()
  // Keep atmosphere relative to the viewed city, rather than the backed-up camera.
  return {fogNear:distance+180,fogFar:distance+900}
}
